import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useMemberTable from '../context/MemberTableContext'
import { QueryClient, useQuery } from '@tanstack/react-query'
import Loader from '../../../../common/loader/Loader'
import Card from '../../../../common/card/Card'
import { performRequest } from '../../../../common/utils'
import InviteLinksTable from './InviteLinksTable'

const InviteLinks = ({ teamType }) => {

  const params = useParams()
  const teamId = params.team_id ?? 0
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchInviteLinks, setSelectedUser, setSelectedModal, setSelectedBulkUser } = useMemberTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['msync_get_org_invite_links'],
      queryFn: requestOrgInviteLinks,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestOrgInviteLinks() {
      const currentRestUrl = window.group_dashboard.base
      const nonce = window.group_dashboard.nonce
      const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/enrollments'

      try {
        const res = await fetch(url, {
            method: 'GET',
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })

        if ( !res.ok ) throw Error(res.statusText)

        const resultJSON = await res.json()
        return resultJSON.response
      } catch (error) {
        console.log(error)
        setResponseMessage( error.toString() )
        return false
      }
    }

    useEffect(() => {
      setRefetchInviteLinks(() => refetch)
      setSelectedUser('')
      setSelectedModal('')
      setSelectedBulkUser('')
    }, [ refetch ])

    if( isLoading || isPending || isFetching ){
      return (
        <Loader type='spinner-dual-ring'/>
      )
    }
  
    if( isError ){
      return (
        <Notice> 
          <strong> { error.message } </strong> 
        </Notice>
      )
    }
    
  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Notice> 
            <strong>{ responseMessage }</strong> 
          </Notice>
        : data && 
          <InviteLinksTable inviteLinksData={ data } />
      }
    </>
  )
}

export default InviteLinks
